import { AfterContentChecked, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatDrawer } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { RoleLevels, RoleNames, RolesWeight } from 'src/app/authentication/auth-helpers';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { ComponentCommunicationService } from 'src/app/core/services/component-communication.service';
import { LoginService } from 'src/app/core/services/login.service';
import { ModelService } from 'src/app/core/services/model.service';
import { RolesService } from 'src/app/core/services/roles.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { Account, AccountData } from 'src/app/model/account';
import { AccountRole } from 'src/app/model/account-role';
import { AppSubscription, Mode, SubscriptionData } from 'src/app/model/subscription';
import { UpdateRoles, UpdateRolesInfo } from 'src/app/model/update-roles';
import { RolesSelectorConfig } from '../roles-selector/roles-selector.component';
import { CmsService } from 'src/app/core/services/cms.service';
import { CmsObject } from 'src/app/model/cmsobject';
import { TableService } from 'src/app/core/services/table.service';
import { ST_Roles, StoreRolesService } from 'src/app/core/services/store-role.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TbAuthService } from '@tb/auth';
import { RoleState, StoreRole } from 'src/app/model/store-role';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
export interface UserData {
    AccountName: string;
    FullName: string;
    Email: string;
    IsEditable: false;
    UserAdmin: false;
    Roles: string;
    Subs: string;
    Disabled: string;
    Confirmed: boolean;
    Locked: boolean;
    MustChangePassword: boolean;
    PasswordNeverExpires: boolean;
    CannotChangePassword: boolean;
    IsCASUser: string;
    Table: string;
    IsClicked: boolean;
}

@Component({
    selector: 'tb-account-management',
    templateUrl: './account-management.component.html',
    styleUrls: ['./account-management.component.scss'],
})
export class AccountManagementComponent implements OnInit, AfterContentChecked, OnDestroy {
    dataSourceUser: MatTableDataSource<UserData>;
    showUserTab: boolean = false;
    showSubscriptionsAssociated: boolean = false;
    authorizationStored = this.loginService.getauthinfo();
    authorizationProperties: AuthorizationProperties = JSON.parse(this.authorizationStored);
    selectedAccount: string;
    listOfAccounts: UserData[];
    userFound: boolean = true;
    searchUser: string = '';
    showTabCA: boolean = false;
    previousAccount: string;
    previousSubscription: string;
    isFirstTimeForAccount: boolean = true;
    isFirstTimeForSubscription: boolean = true;
    listOfSubscription: SubscriptionData[];
    @ViewChild('drawer') drawer: MatDrawer;
    canShowDetail = false;
    currentsubscriptionKey = '';
    IsNotCreatedByYou: boolean = false;
    accountDetail: AccountData;
    @ViewChild(MatTable) accountsTable: MatTable<UserData>;
    showFilterOptions = false;
    count: number;
    disableCheckbox: boolean = false;
    isSaveEvent: boolean = false;
    roleLevelAccount: UpdateRoles[] = [];
    copyOfRoleLevelAccount: UpdateRoles[] = [];
    updateRoles: UpdateRolesInfo;
    prova: RolesSelectorConfig;
    isDevOpsOrHigher = false;
    public eMailAccount: string = '';
    public cmsObj: CmsObject[];
    language: string;
    accountNameToSet: string;
    currentAccountLogged: Account;
    isLoggedAccountInternal = false;
    isDevOpsOrSysAdmin = false;
    isUserAdmin = false;
    public isZucchettiDirettaUser = false;

    constructor(
        private modelService: ModelService,
        private loginService: LoginService,
        private workFlow: WorkFlowService,
        private variable: TranslatedVariables,
        private cdr: ChangeDetectorRef,
        private rolesService: RolesService,
        private snackBar: MatSnackBar,
        private componentCommunicationService: ComponentCommunicationService,
        public cmsService: CmsService,
        public workflow: WorkFlowService,
        private tableService: TableService,
        private storeRoleService: StoreRolesService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private authService: TbAuthService,
        private subscriptionService: SubscriptionService
    ) {
        this.accountDetail = new AccountData();
        this.updateRoles = new UpdateRolesInfo();
    }

    async ngOnInit() {
        this.activatedRoute.queryParams.subscribe((params) => {
            this.accountNameToSet = params['accountName'];
        });
        this.getCmsObj();
        this.isDevOpsOrHigher = this.rolesService.checkRolesMin(RolesWeight.DEVOPS);
        await this.getInfoAccount();
        await this.getAccountHomeInfo();
    }

    async getInfoAccount() {
        let opRes = await this.loginService.getAccountToPromiseBy(this.authorizationProperties.accountName);
        //Code 32 vuol dire che il token è scaduto
        if (opRes['Result']) {
            this.currentAccountLogged = opRes['Content'];
        } else {
            this.currentAccountLogged = undefined;
        }
    }

    ngAfterContentChecked() {
        this.cdr.detectChanges();
    }

    async getCmsObj() {
        this.language = this.workflow.getLanguageForCms();
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(this.language, 'twofa');
    }

    showTabs(row: any) {
        this.showTabCA = false;
        console.log('showTabs');
        this.setAccountName(row.AccountName);
        this.closeDrawer();
    }

    async getAccountHomeInfo() {
        let opRes = await this.modelService.getAccountHomeInfoToPromise(this.authorizationProperties.accountName);
        if (!opRes.Result || opRes['Content'].length === 0) {
            //this.workFlow.showMessage(this.variable.errorTitle, opRes['Message']);
            return;
        }
        this.listOfAccounts = opRes['Content'].filter((x) => x.AccountName !== 'root.cloud@microarea.it');
        this.listOfAccounts.map((x) => (x.Table = 'user'));
        if (this.accountNameToSet && this.listOfAccounts.some((x) => x.AccountName === this.accountNameToSet)) {
            console.log('getAccountHomeInfo 1');
            this.setAccountName(this.accountNameToSet);
        } else {
            // Remove query params
            this.router.navigate([], {
                queryParams: {
                    accountName: null,
                },
                queryParamsHandling: 'merge',
            });
            console.log('getAccountHomeInfo 2');
            this.setAccountName(this.listOfAccounts[0].AccountName);
        }
        this.dataSourceUser = new MatTableDataSource(this.listOfAccounts);
        this.cdr.detectChanges();
        // this.dataSourceUser.paginator = this._paginatorUsers;
    }

    setAccountName(element: string) {
        if (element === this.selectedAccount) {
            return;
        }
        let accountSel = this.listOfAccounts.filter((x) => x.AccountName === element);
        this.eMailAccount = !accountSel || accountSel.length == 0 ? 'simona.podesta@zucchetti.com' : accountSel[0].Email;
        let isEditable = accountSel.map((x) => x.IsEditable)[0];
        if (!isEditable) {
            this.IsNotCreatedByYou = true;
            // return;
        } else {
            this.IsNotCreatedByYou = false;
        }
        this.changeBackgroundAccount(element);
        this.selectedAccount = element;
        this.showUserTab = true;
        this.showSubscriptionsAssociated = true;
        this.setDataRoles();
    }

    async openDrawer(row: any) {
        let newRoles: any = this.listOfSubscription.filter((x) => x.SubscriptionKey === row.SubscriptionKey).map((x) => x.Roles)[0];
        this.isLoggedAccountInternal = newRoles.some((r) => r.RoleName === RoleNames.Internal);
        this.isDevOpsOrSysAdmin = newRoles.some((r) => r.Weight === RolesWeight.DEVOPS || r.Weight === RolesWeight.SYSADMIN);

        this.isUserAdmin = newRoles.some(
            (r) =>
                r.Weight === RolesWeight.USERADMIN && r.EntityKey === this.currentsubscriptionKey && r.RoleLevel === RoleLevels.Subscription
        );
        this.isZucchettiDirettaUser = this.storeRoleService.isZucchettiAccount;

        this.currentsubscriptionKey = row.SubscriptionKey;
        this.accountDetail = new AccountData();
        this.accountDetail.AccountName = this.selectedAccount;
        this.accountDetail.Roles = newRoles;
        this.accountDetail.CreationDate = row.CreationDate;
        this.accountDetail.ExpirationDate = row.ExpirationDate;
        this.setRolesTabsVisibility(this.accountDetail);
        this.canShowDetail = true;
        this.drawer.open();
    }

    async setRolesTabsVisibility(row: AccountData) {
        let opRes = await this.subscriptionService.getSubscriptionsToPromise(
            this.authorizationProperties.accountName,
            this.currentsubscriptionKey
        );
        if (!opRes['Result']) {
            this.accountDetail.ShowAdministrativeRoles = false;
            this.accountDetail.ShowApplicationeRoles = false;
        } else {
            let subscriptions: AppSubscription[] = opRes['Content'];
            let amIaCASUSer =
                this.currentAccountLogged && this.currentAccountLogged.CASUser ? this.currentAccountLogged.CASUser.length > 0 : false;
            this.accountDetail = row;
            let isSubscriptionRtm = subscriptions[0].SubscriptionToken.mode === Mode.rtm;

            if (this.isLoggedAccountInternal && (this.isUserAdmin || this.isDevOpsOrSysAdmin) && !isSubscriptionRtm) {
                this.accountDetail.ShowAdministrativeRoles = true;
                this.accountDetail.ShowApplicationeRoles = true;
            } else {
                if ((amIaCASUSer || this.isZucchettiDirettaUser) && (this.isUserAdmin || this.isDevOpsOrSysAdmin)) {
                    this.accountDetail.ShowAdministrativeRoles = this.accountDetail.CasUser && this.accountDetail.CasUser.length > 0; // è un CAS account
                    this.accountDetail.ShowApplicationeRoles = !this.accountDetail.CasUser || this.accountDetail.CasUser.length == 0; //non è un CAS account
                } else {
                    this.accountDetail.ShowAdministrativeRoles = false;
                    this.accountDetail.ShowApplicationeRoles = false;
                }
            }
        }
    }

    closeDrawer(accountName?: string) {
        if (accountName) {
            this.selectedAccount = accountName;
        }
        this.drawer.close();
    }

    showTabCreationAccount() {
        this.showTabCA = true;
        this.IsNotCreatedByYou = false;
        this.listOfAccounts.map((x) => (x.IsClicked = false));
        this.selectedAccount = '';
    }

    changeBackgroundAccount(accountName: any) {
        if (!this.isFirstTimeForAccount) {
            this.listOfAccounts.filter((x) => x.AccountName === this.previousAccount).map((x) => (x.IsClicked = false));
        }
        this.isFirstTimeForAccount = false;
        this.listOfAccounts.filter((x) => x.AccountName === accountName).map((x) => (x.IsClicked = true));
        this.previousAccount = this.listOfAccounts.filter((x) => x.AccountName === accountName)[0].AccountName;
    }

    changeBackgroundSubscription(subscriptionKey: any) {
        if (!this.isFirstTimeForSubscription) {
            this.listOfSubscription.filter((x) => x.SubscriptionKey === this.previousSubscription).map((x) => (x.IsClicked = false));
        }
        this.isFirstTimeForSubscription = false;
        this.listOfSubscription.filter((x) => x.SubscriptionKey === subscriptionKey).map((x) => (x.IsClicked = true));
        this.previousSubscription = this.listOfSubscription.filter((x) => x.SubscriptionKey === subscriptionKey)[0].SubscriptionKey;
    }

    setRoles() {
        this.isSaveEvent = true;
        this.closeDrawer();
    }

    setSaveEvent() {
        this.isSaveEvent = false;
    }

    setHowManyUserAdmin(element: SubscriptionData[]): boolean {
        let roles;
        this.count = 0;
        for (let i = 0; i < element.length; i++) {
            roles = element.map((x) => x.Roles)[i];
            if (roles.some((x) => x === RoleNames.User_admin)) {
                this.count++;
            }
        }
        if (this.count === 1) {
            this.disableCheckbox = true;
            return;
        }
        this.disableCheckbox = false;
        return;
    }

    async onSaveAccount(accountName: string) {
        if (!accountName) {
            return;
        } else {
            this.showTabCA = false;
            await this.getAccountHomeInfo();
            console.log('onSaveAccount');
            this.setAccountName(accountName);
            this.applyFilter(accountName, false);
            this.listOfAccounts.filter((x) => x.AccountName === this.selectedAccount).map((x) => (x.IsClicked = true));
        }
    }

    initializeList(event: any) {
        this.listOfSubscription = event;
        this.setHowManyUserAdmin(this.listOfSubscription);
    }

    doSomething(something: any) {
        this.updateTable(this.authorizationProperties.accountName, something.value);
        if (this.accountsTable !== undefined) this.accountsTable.renderRows();
    }

    updateTable(accountName: string, selected: string) {
        this.modelService.getAccountHomeInfo(accountName).subscribe(
            async (accounts) => {
                const opRes: boolean = accounts['Result'];
                if (!opRes) {
                    return;
                } else {
                    let listAccountName = accounts['Content'];
                    switch (selected) {
                        case 'Lista dei tuoi account':
                            this.listOfAccounts = listAccountName.filter((x: { IsEditable: boolean }) => x.IsEditable === true);
                            this.dataSourceUser = new MatTableDataSource<UserData>(this.listOfAccounts);
                            break;
                        case 'Lista degli account non modificabili':
                            // if (!this.isDevOpsOrHigher) {
                            this.listOfAccounts = listAccountName.filter((x: { IsEditable: boolean }) => x.IsEditable === false);
                            this.dataSourceUser = new MatTableDataSource<UserData>(this.listOfAccounts);
                            break;
                        // }
                        case 'Account disabilitati':
                            this.listOfAccounts = listAccountName.filter((x: { Disabled: boolean }) => x.Disabled === true);
                            this.dataSourceUser = new MatTableDataSource<UserData>(this.listOfAccounts);
                            break;
                        case 'Account confermati':
                            this.listOfAccounts = listAccountName.filter((x: { Confirmed: boolean }) => x.Confirmed === true);
                            this.dataSourceUser = new MatTableDataSource<UserData>(this.listOfAccounts);
                            break;
                        case 'Account non confermati':
                            this.listOfAccounts = listAccountName.filter((x: { Confirmed: boolean }) => x.Confirmed === false);
                            this.dataSourceUser = new MatTableDataSource<UserData>(this.listOfAccounts);
                            break;
                        case 'Account bloccati':
                            this.listOfAccounts = listAccountName.filter((x: { Locked: boolean }) => x.Locked === true);
                            this.dataSourceUser = new MatTableDataSource<UserData>(this.listOfAccounts);
                            break;
                        case 'Devono cambiare la password':
                            this.listOfAccounts = listAccountName.filter(
                                (x: { MustChangePassword: boolean }) => x.MustChangePassword === true
                            );
                            this.dataSourceUser = new MatTableDataSource<UserData>(this.listOfAccounts);
                            break;
                        default:
                            this.listOfAccounts = listAccountName.filter((x) => x.AccountName !== 'root.cloud@microarea.it');
                            this.dataSourceUser = new MatTableDataSource<UserData>(this.listOfAccounts);
                            break;
                    }
                    this.showFilterOptions = true;
                    if (this.listOfAccounts.length === 0) {
                        this.userFound = false;
                        return;
                    }
                    this.userFound = true;
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    async setDataRoles() {
        let opRes = await this.rolesService.getRolesToPromiseBy(this.selectedAccount);
        let roles: AccountRole[] = opRes['Content'];
        let selectedRoles = roles.filter((x) => x.RoleLevel === RoleLevels.All).map((x) => x.RoleName);
        this.prova = {
            Roles: selectedRoles.map((x) => ({
                roleName: x,
                roleLevel: RoleLevels.Account,
                selected: true,
                accountSelected: this.selectedAccount,
                subscription: RoleLevels.All,
                parentAccountName: this.authorizationProperties.accountName,
                disableCheckbox: false,
                needsLevelAll: true,
            })),
        };
        this.updateSectionRoles();
    }

    updateSectionRoles() {
        this.roleLevelAccount = [];
        this.copyOfRoleLevelAccount = [];
        let roleLevelAccount;
        if (this.isDevOpsOrHigher) {
            roleLevelAccount = [
                {
                    RoleName: 'INTERNAL',
                    Description: 'microarea internal purpose (accounts, subscriptions)',
                },
                {
                    RoleName: 'DEVELOPER',
                    Description: 'M4 Cloud Developer (accounts, subscriptions, instances)',
                },
                {
                    RoleName: 'DEVOPS',
                    Description: 'sysadmin in questo Domain (accounts, subscriptions, instances, this domain)',
                },
                {
                    RoleName: 'SYS-ADMIN',
                    Description: 'dio (accounts, subscriptions, instances, domains)',
                },
                {
                    RoleName: 'EXTERNAL-DVLP',
                    Description: 'M4 Cloud External Developer on Develop Environment (polpino,accounts, subscriptions, instances)',
                },
                {
                    RoleName: 'ESP-ADMIN',
                    Description: 'visione di tutte le sub dello snapshot nel front-end di ESP ',
                },
                {
                    RoleName: 'CMS-ADMIN',
                    Description: 'visione della sezione del CMS manager nello store',
                },
                {
                    RoleName: 'INDUSTRIES-EDITOR-ADMIN',
                    Description: "visione e modifica dell'industries-editor nello store",
                },
                {
                    RoleName: 'AMAZON-DSP',
                    Description: 'visione della sezione di store dedicata',
                },
            ];
        } else {
            roleLevelAccount = [
                {
                    RoleName: 'EXTERNAL-DVLP',
                    Description: 'M4 Cloud External Developer on Develop Environment (polpino,accounts, subscriptions, instances)',
                },
            ];
        }
        for (var j: number = 0; j < roleLevelAccount.length; j++) {
            let existRole = this.prova.Roles.some((k) => k.roleName.trim() === roleLevelAccount[j].RoleName);
            this.roleLevelAccount.push({
                RoleName: roleLevelAccount[j].RoleName,
                Description: roleLevelAccount[j].Description,
                Value: existRole,
                IsModified: false,
                AccountName: this.selectedAccount,
                Weight: roleLevelAccount[j],
            });
            this.copyOfRoleLevelAccount.push({
                RoleName: roleLevelAccount[j].RoleName,
                Description: roleLevelAccount[j].Description,
                Value: existRole,
                IsModified: false,
                AccountName: this.selectedAccount,
                Weight: roleLevelAccount[j].Weight,
            });
        }
    }

    onValueChange(event: any, i: number) {
        if (this.roleLevelAccount[i].Value === event.checked) {
            this.roleLevelAccount[i].IsModified = false;
        } else {
            this.roleLevelAccount[i].IsModified = true;
        }
    }

    nothingHasChanged() {
        if (JSON.stringify(this.roleLevelAccount) === JSON.stringify(this.copyOfRoleLevelAccount)) {
            return true;
        }
        return false;
    }

    cancel() {
        this.roleLevelAccount = [];
        for (var j: number = 0; j < this.copyOfRoleLevelAccount.length; j++) {
            this.roleLevelAccount.push({
                RoleName: this.copyOfRoleLevelAccount[j].RoleName,
                Description: this.copyOfRoleLevelAccount[j].Description,
                Value: this.copyOfRoleLevelAccount[j].Value,
                IsModified: this.copyOfRoleLevelAccount[j].IsModified,
                AccountName: this.selectedAccount,
                Weight: this.copyOfRoleLevelAccount[j].Weight,
            });
        }
    }

    onSaveChanges() {
        let accountRoleToAdd: UpdateRoles[] = [];
        for (let i = 0; i < this.roleLevelAccount.length; i++) {
            accountRoleToAdd.push(this.roleLevelAccount[i]);
        }
        this.prova.Roles.map((x) => (x.roleLevel = '*'));

        // stringhe vuote per evitare che su db venisse inserito, sui ruoli con level account (internal, devel, devosp, sysad),
        // la quaterna (accountName, ruolo, ACCOUNT, *) quando in realtà ci deve essere (accountName, ruolo, *, *)
        //  ma solo * veniva visto come tentativo di sqlInjection. il level ACCOUNT serve per distingui
        this.updateRoles.assign('', RoleLevels.Account, this.selectedAccount, this.authorizationProperties.accountName, accountRoleToAdd);
        this.rolesService.updateRoleAssociation(this.updateRoles).subscribe(
            (res) => {
                if (!res.Result) {
                    // this.closeDialog();
                    this.snackBar.open(`${this.variable.operationFailed}${res.Message}`, 'OK', { duration: 5000 });
                    return;
                }
                for (var i: number = 0; i < accountRoleToAdd.length; i++) {
                    let roleToAddORremove: StoreRole[] = [];
                    //se è internal aggiungo il ruolo dello store
                    let updatedRole = accountRoleToAdd[i];
                    let role = new StoreRole();
                    role.Description = updatedRole.Description;
                    role.Disabled = 0;
                    role.RoleName = 'ST_' + updatedRole.RoleName;

                    if (updatedRole.RoleName == 'INTERNAL' && updatedRole.IsModified == true) {
                        if (updatedRole.Value == false) {
                            //è stato aggiunto
                            this.storeRoleService.setST_Roles(this.selectedAccount, ST_Roles[ST_Roles.ST_INTERNAL].toString());
                            role.State = RoleState.Added;
                        } else {
                            this.storeRoleService.removeRoleFromSession(ST_Roles[ST_Roles.ST_INTERNAL].toString(), this.selectedAccount);
                            role.State = RoleState.Deleted;
                        }
                        roleToAddORremove.push(role);
                        this.storeRoleService.setOrRemoveST_Roles(
                            this.authorizationProperties.accountName,
                            this.selectedAccount,
                            roleToAddORremove
                        );
                    }
                    this.roleLevelAccount.filter((x) => x.IsModified === true).map((x) => (x.Value = !x.Value));
                }
                this.roleLevelAccount.map((x) => (x.IsModified = false));
                this.copyOfRoleLevelAccount = [];
                for (var j: number = 0; j < this.roleLevelAccount.length; j++) {
                    this.copyOfRoleLevelAccount.push({
                        RoleName: this.roleLevelAccount[j].RoleName,
                        Description: this.roleLevelAccount[j].Description,
                        Value: this.roleLevelAccount[j].Value,
                        IsModified: this.roleLevelAccount[j].IsModified,
                        AccountName: this.selectedAccount,
                        Weight: this.roleLevelAccount[j].Weight,
                    });
                }
                this.componentCommunicationService.sendMessage(this.updateRoles);
                this.snackBar.open(this.variable.operationSucceeded, 'OK', { duration: 5000 });
            },
            (err) => {
                this.snackBar.open(`${this.variable.errorTitle}${err.message}`, 'OK', { duration: 5000 });
            }
        );
    }

    applyFilter(event: string, hasBeenTyped?: boolean) {
        if (hasBeenTyped === undefined) {
            hasBeenTyped = true;
        } else if (hasBeenTyped === false) {
            this.searchUser = event;
        }
        let result = this.tableService.applyFilter(event, hasBeenTyped, this.dataSourceUser);
        if (result) {
            this.userFound = true;
            this.showFilterOptions = true;
        } else {
            this.userFound = false;
            this.showFilterOptions = false;
        }
    }

    ngOnDestroy() {
        if (this.authService.isSessionStorage()) {
            sessionStorage.removeItem('accountToRedirect');
        } else {
            localStorage.removeItem('accountToRedirect');
        }
    }
}
